<template>
  <div class="Enchants h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      :getHref="this.getHref"
      category="enchant"
      :options="options"
      :func1="this.enchant"
      :smallScreen="smallScreen"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/One-ItemTable";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Enchants",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      fields: [
        {
          key: "name",
          sortable: false,
        },
        {
          key: "group",
          sortable: false,
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "change",
          tdClass: "text-nowrap, text-right",
          thClass: "text-right",
        },
        {
          key: "divine",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
      options: [
        { text: "All", value: "All", disabled: false },
        { text: "Helmets", value: "helmets", disabled: false },
        { text: "Boots", value: "boots", disabled: false },
        { text: "Gloves", value: "gloves", disabled: false },
      ],
      type: "All",
      oldType: "All",
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getHref(item) {
      if (item != undefined) {
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"name":"${item}","stats":[{"type":"and","filters":[]}]},"sort":{"price":"asc"}}`;
      }
    },
    enchant(val, item) {
      if (item.group == val) {
        return true;
      }
      return false;
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
